import { useCompany } from "Components/Company/hooks/useCompany";
import { useCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import { useProfile } from "Components/Profile/hooks/useProfile";

export const useIsInitializingAuthDocs = () => {
	const isInitializingProfile = useProfile((state) => state.isInitializing);
	const isInitializingCompany = useCompany((state) => state.isInitializing);
	const isInitializingCompanySetting = useCompanySetting(
		(state) => state.isInitializing
	);

	return (
		isInitializingProfile ||
		isInitializingCompany ||
		isInitializingCompanySetting
	);
};
